import {
  BookWidgetAirportUpdateInfo,
  TripTypeOptions
} from '@com-delta-idp/mnx-capability-flight-shop-ui';
import { BookWidgetState } from '../../models/states/book-widget-state.interfaces';

export const updateBookWidgetOriginAirportFn = (
  state: BookWidgetState,
  bookWidgetAirportUpdateInfo: BookWidgetAirportUpdateInfo
) => {
  const updatedAirportsField = state.fields.airportsField.airports.map(
    (airport, index) =>
      index === bookWidgetAirportUpdateInfo.flightIndex
        ? {
            ...airport,
            fromAirportcode: bookWidgetAirportUpdateInfo.airportCode,
            fromCity: bookWidgetAirportUpdateInfo.airportCity
          }
        : airport
  );

  return updatedAirportsField;
};

export const updateBookWidgetDestinationAirportFn = (
  state: BookWidgetState,
  bookWidgetAirportUpdateInfo: BookWidgetAirportUpdateInfo
) => {
  const isMultiCity =
    state.fields.tripTypesField.selectedTripType === TripTypeOptions.MULTI_CITY;
  const nextIndex = bookWidgetAirportUpdateInfo.flightIndex + 1;

  const updatedAirportsField = state.fields.airportsField.airports.map(
    (airport, index) => {
      if (index === bookWidgetAirportUpdateInfo.flightIndex) {
        return {
          ...airport,
          toAirportcode: bookWidgetAirportUpdateInfo.airportCode,
          toCity: bookWidgetAirportUpdateInfo.airportCity
        };
      }
      if (isMultiCity && index === nextIndex) {
        return {
          ...airport,
          fromAirportcode: bookWidgetAirportUpdateInfo.airportCode,
          fromCity: bookWidgetAirportUpdateInfo.airportCity
        };
      }
      return airport;
    }
  );

  return updatedAirportsField;
};

export const updateBookWidgetConnectionAirportFn = (
  state: BookWidgetState,
  bookWidgetAirportUpdateInfo: BookWidgetAirportUpdateInfo
) => {
  const updatedAirportsField = state.fields.airportsField.airports.map(
    (airport, index) =>
      index === bookWidgetAirportUpdateInfo.flightIndex
        ? {
            ...airport,
            connectionAirport: bookWidgetAirportUpdateInfo.airportCode,
            connectionCity: bookWidgetAirportUpdateInfo.airportCity
          }
        : airport
  );

  return updatedAirportsField;
};
